<ng-container *ngIf="showEllipsisLoader; else defaultLoader">
  <ng-template [ngTemplateOutlet]="ellipsisLoader"></ng-template>
</ng-container>

<ng-template #defaultLoader>
  <div class="spinner" [ngClass]="theme">
    <div
      *ngFor="let a of fakeArray; let index = index"
      class="spinner__item"
      [ngClass]="'spinner__item--' + theme"
    ></div>
  </div>
</ng-template>

<ng-template #ellipsisLoader>
  <div class="lds-ellipsis" [ngClass]="theme">
    <div
      *ngFor="let a of fakeArray; let index = index"
      class="lds-ellipsis__item"
      [ngClass]="'lds-ellipsis__item--' + theme"
    ></div>
  </div>
</ng-template>
